<template>
  <div class="payModal">
    <el-dialog title="课程购买" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
      <div class="pay_content">
        <div class="pay_item">
          <div class="label">订单号：</div>
          <div class="value" >{{ confirmData.orderKey }}</div>
        </div>
        <div class="pay_item">
          <div class="label">价格：</div>
          <div class="value" >{{ confirmData.totalPrice + '元' }}</div>
        </div>
        <div class="pay_item" v-for="(item, index) in confirmData.buyConfigList" :key="index">
          <div class="label"></div>
          <div class="value" >
            {{ item['cateName'] }} {{ item.price + '元'}}
          </div>
        </div>
<!--        <div class="pay_item" v-if="item.key !== 'buyConfigList'">-->
<!--          <div class="label">{{ item.name + "：" }}</div>-->
<!--          <div class="value" v-if="item.key === 'totalPrice'">{{ confirmData[item.key] + '元' }}</div>-->
<!--          <div class="value" v-else>{{ confirmData[item.key] }} {{ item.key }}</div>-->
<!--        </div>-->
<!--        <template v-for="item in confirmData">-->
<!--          <div class="pay_item" v-if="item.key !== 'buyConfigList'">-->
<!--            <div class="label">{{ item.name + "：" }}</div>-->
<!--            <div class="value" v-if="item.key === 'totalPrice'">{{ confirmData[item.key] + '元' }}</div>-->
<!--            <div class="value" v-else>{{ confirmData[item.key] }} {{ item.key }}</div>-->
<!--          </div>-->
<!--        </template>-->
<!--        <template v-for="item in confirmData">-->
<!--          <div class="pay_item" v-if="item.key !== 'buyConfigList'">-->
<!--            <div class="label">{{ item.name + "：" }}</div>-->
<!--            <div class="value" v-if="item.key === 'totalPrice'">{{ orderList[item.key] + '元' }}</div>-->
<!--            <div class="value" v-else>{{ orderList[item.key] }} {{ item.key }}</div>-->
<!--          </div>-->
<!--        </template>-->
        <div class="pay_item">
          <div class="label">支付方式：</div>
          <div class="pay_type">
            <el-radio v-model="payType" label="alipay" border>支付宝支付</el-radio>
<!--            <el-radio v-model="payType" label="weixin" border>微信支付</el-radio>-->
          </div>
        </div>
        <div class="pay_account">
          <div class="label">公户信息：</div>
          <div class="account-box">
            <div class="account-line">
              <span class="account-key">账户名称</span>
              <span class="account-txt">济南鲁凝教育咨询服务有限公司</span>
            </div>
            <div class="account-line">
              <span class="account-key">账户号码</span>
              <span class="account-txt">1602157109100161709</span>
            </div>
            <div class="account-line">
              <span class="account-key">开户银行</span>
              <span class="account-txt">中国工商银行股份有限公司济南万达广场支行</span>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmOrder">确认购买</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import { toAliPay } from '@/api/alipay'

export default {
  name: "payModal",
  data() {
    return {
      dialogVisible: false,
      payType: 'alipay',
      payList: [
        { key: 'orderKey', name: "课程订单" },
        { key: 'buyConfigList', name: "所购商品"},
        { key: 'totalPrice', name: "价格" },
      ],
      confirmData: {},
      url: '',
      // 新窗口的引用
      newWin: null,
    };
  },
  watch: {
    url(newVal, oldVal) {
      if (newVal && this.newWin) {
        this.newWin.sessionStorage.clear()
        this.newWin.location.href = newVal
        // 重定向后把url和newWin重置
        this.url = ''
        this.newWin = null
      }
    }
  },
  created() {

  },
  methods: {
    handleClose() {
      this.dialogVisible = false
     },
    //  打开弹窗
     open(data){
      this.confirmData = data
      this.dialogVisible = true
     },
    //  确认订单
     async confirmOrder(){
       this.loading = true
       // 先打开一个空的新窗口，再请求
       this.newWin = window.open()
       let url = ''
       if (/(Android)/i.test(navigator.userAgent)) { // 判断是否为Android手机
         url = 'order/toPayAsWeb'
       } else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { // 判断是否为苹果手机
         url = 'order/toPayAsWeb'
       } else {
         url = 'order/toPayAsPC'
       }

       let form = {
         subject: "购买课程",
         totalAmount: this.confirmData.totalPrice,
         body: this.confirmData.orderKey,
       }
       toAliPay(url, form).then(res => {
         this.loading = false
         this.url = res.data.payUrl
       }).catch(err => {
         this.loading = false
         console.log(err)
       })
     }

  },
};
</script>
<style scoped lang="scss">
.payModal {
  .pay_content {
    .pay_item {
      display: flex;
      align-items: center;
      margin-bottom: 30px;
      height: 20px;

      .label {
        font-size: 16px;
        width: 100px;
        text-align: right;
      }

      .value {
        text-align: center;
      }
    }

    .pay_item1 {
      display: flex;
      align-items: center;
      margin-bottom: 30px;

      .label {
        font-size: 16px;
        width: 100px;
        text-align: right;
      }

      .value {
        text-align: center;
      }
    }

    .pay_type {
      display: flex;
    }

    .pay_account {
      display: flex;
      align-items: flex-start;

      .label {
        font-size: 16px;
        width: 100px;
        text-align: right;
        flex-shrink: 0;
        line-height: 26px;
      }

      .account-box {
        flex: 1;
        min-width: 0;
        padding: 8px 14px;
        background: #f7f9fc;
        border: 1px solid #e3e8ef;
        border-radius: 2px;

        .account-line {
          display: flex;
          font-size: 14px;
          line-height: 26px;

          .account-key {
            flex-shrink: 0;
            width: 76px;
            color: #8a94a6;
          }

          .account-txt {
            color: #333;
            word-break: break-all;
          }
        }
      }
    }
  }

}
</style>